
import {
  dateStringFromDate,
  dateFromString,
  currencyFormat
} from "../assets/js/paydownData";
import { createAccount } from "../models";
import { mapGetters } from "vuex";
import { GETTERS } from "../data";
import { defineComponent } from "vue";
import { DebtAccount } from "../interfaces";

export default defineComponent({
  name: "NewAccountForm",
  emits: ["submitform", "resetform"],
  props: {
    accountId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      account: createAccount() as DebtAccount,
      dateOpened: "",
      errorMessage: ""
    };
  },
  methods: {
    ...mapGetters([GETTERS.getAccountById]),
    submitForm() {
      let interest = this.account.balance * (this.account.apr / 1200);
      if (interest >= this.account.minPayment) {
        this.errorMessage = `Minimum payment will not cover interest of ${currencyFormat(
          interest
        )}.`;
      } else {
        this.errorMessage = "";
        this.account.dateOpened = dateFromString(this.dateOpened);
        this.$emit("submitform", this.account);
      }
    },
    resetForm() {
      this.errorMessage = "";
      this.account = createAccount();
      this.$emit("resetform");
    }
  },
  mounted() {
    this.account =
      this.accountId !== ""
        ? createAccount(this[GETTERS.getAccountById]()(this.accountId))
        : createAccount();
    this.dateOpened =
      this.accountId !== ""
        ? dateStringFromDate(
            this[GETTERS.getAccountById]()(this.accountId).dateOpened
          )
        : dateStringFromDate(new Date(Date.now()));
  }
});
